import React, { createContext, useContext } from 'react';
import toast from 'react-hot-toast';
import { useAuthStore } from '../store/useAuthStore';
import { authService } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const { login, logout: storeLogout } = useAuthStore();

  async function signIn(loginValue, password) {
    const result = await authService.login(loginValue, password);
    login(result.token, result.user, result.tenant);
    toast.success(`Bem-vinda, ${result.user.name}.`);
  }

  function logout() {
    storeLogout();
    toast('Sessão encerrada.', { icon: '👋' });
  }

  return (
    <AuthContext.Provider value={{ signIn, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuthContext = () => useContext(AuthContext);
